document.addEventListener( 'DOMContentLoaded', function () {
  const mobileAccordionHeading = document.querySelector( '.e-col--side-filter > p' );
  const filterMainWrapper = document.querySelector( '.e-col--side-filter .e-div--filter-main-wrapper' );
  const mediaQuery = window.matchMedia( '(max-width: 992px)' );

  if ( mobileAccordionHeading && filterMainWrapper ) {
    initFilterBoxAccordions( mediaQuery );

    handleMainFilterAccordion( mobileAccordionHeading, filterMainWrapper, mediaQuery );

    mediaQuery.addEventListener( 'change', function ( e ) {
      handleMediaQueryChange( e, filterMainWrapper );
    } );
  }
} );


// Function to initialize the accordion behavior for each filter box
function initFilterBoxAccordions( mediaQuery ) {
  const filterBoxWrappers = document.querySelectorAll( '.e-col--side-filter .e-div--filter-box-wrapper' );
  
  filterBoxWrappers.forEach( function ( div ) {
    const facetDiv = div.querySelector( '.facetwp-facet' );
    const pTag = div.querySelector( 'p' );

    // Make all expanded on initial load
    setInitialActiveState( div, facetDiv, pTag );

    function handleAccordionClick() {
      toggleAccordionState( facetDiv, pTag, div );
    }

    // Add or remove click event listeners based on the media query
    manageAccordionEventListeners( pTag, handleAccordionClick, mediaQuery );
  } );
}

// Function to set the initial active state for the accordion
function setInitialActiveState( div, facetDiv, pTag ) {
  facetDiv.classList.add( 'active' );
  pTag.classList.add( 'active' );
  div.classList.add( 'active' );
  facetDiv.style.maxHeight = 'unset';
}

// Function to toggle accordion state (open/close)
function toggleAccordionState( facetDiv, pTag, div ) {
  facetDiv.classList.toggle( 'active' );
  pTag.classList.toggle( 'active' );
  div.classList.toggle( 'active' );

  if ( facetDiv.classList.contains( 'active' ) ) {
    facetDiv.style.maxHeight = facetDiv.scrollHeight + 'px';
  } else {
    facetDiv.style.maxHeight = '0';
  }
}

// Function to manage the addition/removal of event listeners based on media query
function manageAccordionEventListeners( pTag, handleAccordionClick, mediaQuery ) {
  if ( !mediaQuery.matches ) {
    pTag.addEventListener( 'click', handleAccordionClick );
  }

  mediaQuery.addEventListener( 'change', function ( e ) {
    if ( e.matches ) {
      pTag.removeEventListener( 'click', handleAccordionClick );
    } else {
      pTag.addEventListener( 'click', handleAccordionClick );
    }
  } );
}

// Function to handle the main filter accordion (for mobile)
function handleMainFilterAccordion( mobileAccordionHeading, filterMainWrapper, mediaQuery ) {
  mobileAccordionHeading.addEventListener( 'click', function () {
    if ( mediaQuery.matches ) {
      toggleMainFilterAccordion( filterMainWrapper );
    }
  } );
}

// Function to toggle the main filter accordion on mobile
function toggleMainFilterAccordion( filterMainWrapper ) {
  filterMainWrapper.classList.toggle( 'active' );

  if ( filterMainWrapper.classList.contains( 'active' ) ) {
    filterMainWrapper.style.maxHeight = filterMainWrapper.scrollHeight + 'px';
  } else {
    filterMainWrapper.style.maxHeight = '0';
  }
}

// Function to handle media query change and reset styles if necessary
function handleMediaQueryChange( e, filterMainWrapper ) {
  if ( !e.matches ) {
    filterMainWrapper.style.maxHeight = 'unset';
  }
}
